class LinkCardsSlider {
	constructor(el, prevButton, nextButton) {
		// `el` is the scroll container `.block-link-cards__carousel-container`
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;
		this.sliderEl = this.el ? this.el.querySelector('.block-link-cards__carousel-slider') : null;
		this.onScroll = this.onScroll.bind(this);
		this.onResize = this.onResize.bind(this);

		if (!this.el) {
			return null;
		}

		if (!this.prevButton || !this.nextButton) {
			return null;
		}

		if (!this.sliderEl) {
			return null;
		}

		// Ensure all cards are visible (undo any Load More / is-hidden that may have been applied to this block)
		const block = this.el.closest('.block-link-cards');
		if (block) {
			block.querySelectorAll('.js-link-card').forEach((card) => {
				card.classList.remove('is-hidden');
				card.classList.add('is-visible');
			});
		}

		this.bindEvents();
		this.recalcStep();
		this.updateButtons();

		return this;
	}

	bindEvents() {
		this.prevButton.addEventListener('click', (e) => {
			e.preventDefault();
			this.scrollByStep(-1);
		});

		this.nextButton.addEventListener('click', (e) => {
			e.preventDefault();
			this.scrollByStep(1);
		});

		this.el.addEventListener('scroll', this.onScroll, { passive: true });
		window.addEventListener('resize', this.onResize);
	}

	onScroll() {
		window.requestAnimationFrame(() => this.updateButtons());
	}

	onResize() {
		this.recalcStep();
		this.updateButtons();
	}

	getGap() {
		if (!this.sliderEl) return 0;
		const styles = window.getComputedStyle(this.sliderEl);
		const gap = parseFloat(styles.gap || styles.columnGap || '0');
		return Number.isFinite(gap) ? gap : 0;
	}

	recalcStep() {
		const firstCard = this.sliderEl.querySelector('.block-link-cards__col');
		if (!firstCard) {
			this.step = 0;
			return;
		}

		const gap = this.getGap();
		const cardWidth = firstCard.getBoundingClientRect().width;
		this.step = cardWidth + gap;
	}

	scrollByStep(direction) {
		if (!this.step) {
			this.recalcStep();
		}

		const left = direction * (this.step || this.el.clientWidth);
		this.el.scrollBy({ left, top: 0, behavior: 'smooth' });
	}

	updateButtons() {
		const maxScrollLeft = this.el.scrollWidth - this.el.clientWidth;
		const scrollLeft = this.el.scrollLeft;

		const atStart = scrollLeft <= 2;
		const atEnd = scrollLeft >= maxScrollLeft - 2;

		this.prevButton.disabled = atStart;
		this.nextButton.disabled = atEnd;
	}
}

export default LinkCardsSlider;

